import { render, staticRenderFns } from "./Submenus.vue?vue&type=template&id=650c44ac"
import script from "./Submenus.vue?vue&type=script&lang=js"
export * from "./Submenus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports